import { useDispatch, useSelector } from "react-redux";
import { useAuthState } from "../../../../Helper/Context/context";
import { useState } from "react";
import { BeneficiaryPlotDetailsPostAPI } from "../../../../Helper/Redux/AdminDashboardSlice/BeneficiaryPlotDetailsSlice";
import { AstricSign } from "../../../../Helper/AstricSign";



const BeneficiaryPlotActionPopup = (props) => {

    const { handleShowAddModal, handleIsPost, ShowAddModal,YearValue, MonthValue, Title } = props
    const { flag, data } = ShowAddModal

    const userDetails = useAuthState();
    const { UserID, token } = userDetails
    const dispatch = useDispatch()

    const [Latitude, setLatitude] = useState(flag == 'Update' ? data?.inputPlotLattitude : '')
    const [Longitude, setLongitude] = useState(flag == 'Update' ? data?.inputPlotLongitude : '')

    const handleSubmit = () => {
        const data = {
            FinancialYearID: YearValue,
            MonthsID: MonthValue,
            T_BeneficiaryWisePlotsDetails_PhotoID: flag == 'Update' ? ShowAddModal.data?.t_BeneficiaryWisePlotsDetails_PhotoID :0 ,
            InputPlotLattitude:Latitude,
            InputPlotLongitude:Longitude,
            M_TableUserMasterID: UserID,
            token: token,
            handleIsPost
        }
        dispatch(BeneficiaryPlotDetailsPostAPI({ data }))
    }

    const { isPostLoading } = useSelector(state => state.BeneficiaryPlotDetailsPostData)

    return (
        <>
            <div className="modal fade show d-flex align-items-center" style={{ display: "block", backgroundColor: "#00000055" }}>
                <div className="modal-dialog modal-xl view_modal_size" role="document"  >
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title fw-bold text-danger modal-title-fs" id="exampleModalLongTitle">{Title}</h5>
                            <button onClick={() => handleShowAddModal(false, '')} type="button" className="close" style={{ marginLeft: "auto" }}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body mx-lg-4">
                            <div className="row">

                                <div className="col-12 col-lg-6 pt-2 mt-3 mt-lg-0 pt-lg-2 my-4">
                                    <div className="form-group m-0">
                                        <span className="fw-bold ">Latitude <AstricSign/></span>
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            name="Latitude"
                                            placeholder="Latitude"
                                            value={Latitude}
                                            onChange={(e) => setLatitude(e.target.value)}

                                        />
                                    </div>

                                </div>

                                <div className="col-12 col-lg-6 pt-2 mt-3 mt-lg-0 pt-lg-2 my-4">
                                    <div className="form-group m-0">
                                        <span className="fw-bold ">Longitude <AstricSign/> </span>
                                        <input
                                            type="text"
                                            className="form-control mt-2"
                                            name="Longitude"
                                            placeholder="Longitude"
                                            value={Longitude}
                                            onChange={(e) => setLongitude(e.target.value)}

                                        />
                                    </div>

                                </div>
                                <div className="col-12 ">
                                    <div className="form-group text-end ">
                                        <button
                                            type='button'
                                            onClick={() => handleSubmit()}
                                            disabled={Latitude == "" || Longitude == ''}
                                            className="btn bg-success text-white border-2 mx-2 px-4" data-ktwizard-type="action-next">
                                            Update
                                        </button>
                                        <button
                                            type="button"
                                            onClick={() => handleShowAddModal(false, '')}
                                            className="btn btn-danger border-2" data-ktwizard-type="action-next">
                                            Cancel
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>);
}

export default BeneficiaryPlotActionPopup;